import { useEffect, useState } from 'react';

import strings from '../../lang/lang';
import Input from '../../elements/Input/Input';
import { ReactComponent as PlusCircleIcon } from '../../styles/icon/plus-circle.svg';
import { ReactComponent as MinusCircleIcon } from '../../styles/icon/minus-circle.svg';
import { useAppSelector } from '../../hooks/useRedux';
import { appDetailsData } from '../../redux/reducers/apps';
import settings from './Settings.module.scss';
import PermissionForm from './PermissionForm';


const isValidUrl = (url) => {
  const pattern = new RegExp(
    '^([a-zA-Z]+:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?((\\/[-a-z\\d%_.~+]*)|(\\/\\*))*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return pattern.test(url);
}

export default function Permissions(props) {
  const { match } = props;
  const data = useAppSelector(appDetailsData);
  const [uri, setUri] = useState('');
  const [uris, setUris] = useState(data && data['redirectUris']);
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [uri, uris]);

  function addUri() {
    const isValid = isValidUrl(uri);
    if (isValid) {
      const urisList = [...uris];
      const hasOne = uris.find((item) => item === uri);
      if (!hasOne) {
        urisList.push(uri);
        setUris(urisList);
        setUri('');
      } else {
        setError('this url already exists');
      }
    } else {
      setError('Please enter a valid URL');
    }
  };

  const removeUri = (id) => {
    const nextUris = uris.filter((v, i) => i !== id);
    setUris(nextUris);
  };

  const renderUriRow = ({ item, id }) => {
    return (
      <div key={id}>
        <div>{item}</div>
        <button className={settings.settings__minus} onClick={() => removeUri(id)}>
          <MinusCircleIcon />
        </button>
      </div>
    );
  };

  const permissionList = data.scopesFullInfo.filter(item => item.availability !== 'COMING_SOON');
  return (
    <div className={settings.settings__wrap} style={data.status === 'BLOCKED' ? { pointerEvents: 'none', opacity: 0.4 } : {}}>
      <h2>{strings.appPermissions.text.title}</h2>
      {data['type'] === 'B2C' && (
        <>
          <div className={settings.settings__title_text}>
            <h3>Redirect URL</h3>
            <p>
              Valid URI pattern a browser can redirect to after a successful login. Simple wildcards
              are allowed such as 'http://example.com/*'.
            </p>
          </div>
          <div
            className={settings.settings__input_box}
          >
            <Input
              id="uri"
              name="uri"
              label="Redirect URL"
              className="input__textfield__settings"
              secondaryClassName="input__textfield__secret"
              autoComplete="off"
              value={uri}
              eventIcon={<PlusCircleIcon />}
              onKeyDown={(event) => {
                if (event.keyCode === 13) {
                  addUri();
                }
              }}
              onChange={e => setUri(e.target.value)}
              onClick={() => addUri()}
              disabled={uris.length > 4}
            />
            {!!error.length && (<div className='error-message'>{error}</div>)}
          </div>
        </>
      )}
      <div className={settings.settings__chosen_box}>
        {uris.length > 0 && (
          <div className={settings.settings__chosen}>
            {uris.map((item, id) =>
              renderUriRow({ item, id })
            )}
          </div>
        )}
      </div>
      <h3>{strings.appPermissions.text.apisTitle}</h3>
      <div className={settings.settings__choose_text}>{strings.appPermissions.text.apisListTitle}</div>
      <PermissionForm
        permissionList={permissionList}
        redirectUris={uris}
        appId={match.params.id}
        initialUris={data['redirectUris'] || []}
      />
    </div>
  );
}
